import { Outlet } from "@vixi/router";
import React from "react";
import { CheckConnection } from "../check-connection";
import ConfirmationDialog from "../confirmation-dialog";

export function RootComponent() {
  return (
    <React.Fragment>
      <CheckConnection />
      <Outlet />
      <ConfirmationDialog />
      <div
        id="tooltip-backdrop"
        className="pointer-events-none absolute top-0 left-0 z-500 h-full w-full bg-black/20 opacity-0 transition-opacity duration-200 has-[*]:opacity-100"
      />
    </React.Fragment>
  );
}
